import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const exportExcelReport = async (appName, dateRange, tables, fileName) => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Report");

  let currentRow = 1;

  // === Base font ===
  const baseFont = { name: "Arial", size: 12 };

  // === Main Title ===
  const mainTitleRow = sheet.getRow(currentRow);
  mainTitleRow.height = 30;
  sheet.mergeCells(`A${currentRow}:Z${currentRow}`);
  const mainTitleCell = mainTitleRow.getCell(1);
  mainTitleCell.value = appName;
  mainTitleCell.font = { ...baseFont, size: 20, bold: true };
  mainTitleCell.alignment = { horizontal: "left", vertical: "middle" };
  currentRow++;

  // === Date Range ===
  const dateRow = sheet.getRow(currentRow);
  sheet.mergeCells(`A${currentRow}:Z${currentRow}`);
  const dateCell = dateRow.getCell(1);
  dateCell.value = `Date Range: ${dateRange}`;
  dateCell.font = { ...baseFont, italic: true };
  dateCell.alignment = { horizontal: "left", vertical: "middle" };
  currentRow += 2;

  // === Tables ===
  tables.forEach((table) => {
    // Table title
    sheet.mergeCells(`A${currentRow}:${String.fromCharCode(64 + table.headers.length)}${currentRow}`);
    const titleCell = sheet.getCell(`A${currentRow}`);
    titleCell.value = table.title;
    titleCell.font = { ...baseFont, size: 14, bold: true };
    titleCell.alignment = { horizontal: "left", vertical: "middle" };
    currentRow++;

    // Header row
    const headerRow = sheet.addRow(table.headers);
    headerRow.eachCell((cell) => {
      cell.font = { ...baseFont, bold: true };
      cell.alignment = { horizontal: "left", vertical: "middle" };
      cell.fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'FFD9E1F2'} }; // only header background
    });
    currentRow++;

    // Data rows
    table.rows.forEach((rowData, rowIndex) => {
      const row = sheet.addRow(rowData);
      row.height = 20;
      const isLastRow = rowIndex === table.rows.length - 1;
      const hasTotal = isLastRow && rowData[0] && typeof rowData[0] === 'string' && rowData[0].toLowerCase().includes('total');
      row.eachCell((cell) => {
        cell.font = hasTotal ? { ...baseFont, bold: true } : baseFont;
        cell.alignment = { horizontal: "left", vertical: "middle" };
      });
      currentRow++;
    });

    currentRow++; // spacing before next table
  });

  // Adjust column widths
  const maxCols = Math.max(...tables.map(t => t.headers.length));
  for (let i = 1; i <= maxCols; i++) {
    sheet.getColumn(i).width = 18;
  }

  // Generate Excel file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, `${fileName}.xlsx`);
};